export const environment = {
  production: false,
  // THIS IS TEST ENDPOINT USE IN DEV, DO NOT MODIFY THIS OR USE IN PRODUCTION
  baseURL: 'https://testconnect.foodismconnect.com/api/v1',
};
